import authRoutesBuilder from '@/mixins/authRoutesBuilder'
import { getTokenSso, getUserSso } from '@/services/API/authentication'
import * as Settings from '@/infra/settings'
import maLoader from '@/components/loaderSmall'
/**
 * @module
 * @name SsoLogin
 * @description
 */
export default {
  name: 'SsoLogin',

  mixins: [authRoutesBuilder],

  data() {
    return {
      loadingSSO: true,
      errorSSO: false
    }
  },
  components: {
    maLoader
  },

  async mounted() {
    console.log('Mounted SSO Login')
    const code = this.$route.query.code

    if (code) {
      await this.processSsoLogin(code)
    } else {
      if (!Settings.getTokenStorage()) {
        this.redirectToCognito()
      } else {
        this.$router.push({ name: 'root' })
      }
    }
  },

  methods: {
    redirectToCognito() {
      const cognitoUrl = process.env.VUE_APP_COGNITO_URL
      const clientId = process.env.VUE_APP_COGNITO_CLIENT_ID
      const redirectUri = encodeURIComponent(process.env.VUE_APP_COGNITO_REDIRECT_URI)

      const url = `${cognitoUrl}/oauth2/authorize?identity_provider=NDBXSSO&client_id=${clientId}&response_type=code&scope=openid%20email&redirect_uri=${redirectUri}`
      window.location.assign(url)
    },

    async processSsoLogin(code) {
      this.loadingSSO = true
      try {
        // Obtener Token mediante el código
        const { token } = await getTokenSso(code, process.env.VUE_APP_COGNITO_REDIRECT_URI)
        this.setToken(token)

        // Marcar que NO es login manual para que el mixin use los endpoints SSO
        localStorage.setItem('user_manual', 'false')

        const userResponse = await getUserSso()
        this.setUser(userResponse, true)

        await this.setRoutes()
      } catch (error) {
        console.error('Error durante el proceso de SSO:', error)
        this.errorSSO = true
      } finally {
        this.loadingSSO = false
      }
    }
  }
}
